import { render, staticRenderFns } from "./NfseEmissionPage.vue?vue&type=template&id=2567197b"
import script from "./NfseEmissionPage.vue?vue&type=script&lang=js"
export * from "./NfseEmissionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports